import axios from 'axios'
import Vue from 'vue'
import router from '@/router'

const GRAPHICS_HTTP_API = axios.create({
  baseURL: process.env.VUE_APP_GRAPHICS_URL,
  headers: { 'Content-Type': 'application/json' }
})
/*
* The interceptor here ensures that we check for the token in local storage every time an ajax request is made
*/
GRAPHICS_HTTP_API.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('web-token')
    var currentDate = new Date();
    if (currentDate.getTime() < sessionStorage.getItem('expDate')) {
      config.headers['Authorization'] = `Bearer ${ token }`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

GRAPHICS_HTTP_API.interceptors.response.use(
  (response) => {
    console.log(response)
    return response
  },
  (error) => {
    if (error == 'Error: Network Error')
      router.push({ name: 'login' })
    return Promise.reject(error)
  }
)

export default GRAPHICS_HTTP_API
